<div class="pt-3">
  <lib-filter-list [configService]="jeevesCustomerDeliveryLocationListConfigService"></lib-filter-list>
</div>
